module.exports = __webpack_public_path__ + "res/ic_add_media_plus.a811a749c1c919b76f03dd51b765b870.png";